import React from 'react';
import logo from '../assets/logofoot.png';
const Footer = () => {
  return (
    <footer className="bg-[#3257A4] text-white py-16 px-6 md:px-20">
      <div className="max-w-8xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-10">
        {/* Left Section */}
        <div>
        <div className='flex'>

    
                <img
                  src={logo}
                  alt="Company Logo"
                  className="h-5 w-[auto]" 
                />
               <div className="flex flex-col  pl-[2%]">
  {/* <span className="text-white-900 font-bold text-xl" style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 600 }}>SRIDANTH</span> */}

</div>
          </div>
          <p className="text-gray-200">
            A gentle toothpaste made with safe ingredients and fun flavors your kids will love.
          </p>
        </div>
        {/* Quick Links */}
        <div>
          <h3 className="text-xl font-semibold mb-4">Quick Links</h3>
          <ul className="space-y-2 text-gray-200">
            <li><a href="/" className="hover:underline">Home</a></li>
            <li><a href="/about" className="hover:underline">About Us</a></li>
            <li><a href="/product" className="hover:underline">Products</a></li>
            <li><a href="/contact" className="hover:underline">Contact</a></li>
          </ul>
        </div>
        {/* Legal */}
        <div>
          <h3 className="text-xl font-semibold mb-4">Legal</h3>
          <ul className="space-y-2 text-gray-200">
            <li><a href="/privacy-policy" className="hover:underline">Privacy Policy</a></li>
            <li><a href="/terms-and-services" className="hover:underline">Terms of Service</a></li>
            <li><a href="/return-policy" className="hover:underline">Return Policy</a></li>
            <li><a href="/shipping-and-refund-policy" className="hover:underline">Shipping and Refund Policy</a></li>
          </ul>
        </div>
        {/* Contact Us */}
        <div>
          <h3 className="text-xl font-semibold mb-4">Contact Us</h3>
          <ul className="space-y-3 text-gray-200">
            <li className="flex items-center space-x-2">
              <span>e-mail:</span>
              <a href="mailto:support@sridanth.com" className="hover:underline">support@sridanth.com</a>
            </li>
            <li className="flex items-center space-x-2">
              <span>telephone_receiver:</span>
              <a href="tel:+911234567890" className="hover:underline">+91 1234567890</a>
            </li>
            <li className="flex items-center space-x-2">
              <span>location:</span>
              <span>Vijayawada, India</span>
            </li>
          </ul>
        </div>
      </div>
      <hr className="border-gray-400 my-10" />
      <div className="text-center text-gray-300 text-sm">
        © {new Date().getFullYear()}  
        <a href='https://oakyaitservices.com/'>OAKYA IT SERVICES PVT LTD
          </a>. All rights reserved.
      </div>
    </footer>
  );
};
export default Footer;